import {JsonConverter, JsonCustomConvert} from 'json2typescript';
import {EmailImage} from '../model/email/emailImage';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';

@JsonConverter
export class EmailImageConverter implements JsonCustomConvert<EmailImage> {

    deserialize(json: any): EmailImage {

        // const msgArr = new Array<TextMessage>();
        // return Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(json,EmailImage);
        /*const temp:TSMap<string,string>= new TSMap();
        for (const key of Object.keys(json)) {
            temp.set(key, json[key]);
        }

        return temp;*/

        // const imageMsgArr:Array<EmailImage =  [];
        // const temp:TSMap<string,EmailBanner>= new TSMap();

        // for (const item of json) {
        // imageMsgArr.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(item,EmailImage));
        // }

        return Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(json, EmailImage);
    }

    serialize(data: EmailImage): any {
        return JSON.stringify(data);
    }
}
